// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_7p-4";
export var collapsed = "_7p-1";
export var headerBar = "_7p-0";
export var leftHeaderContent = "_7p-3";
export var subjectContainer = "_7p-2";